// import React, { useState, useEffect } from "react";
// import { View, Text, Button, FlatList, StyleSheet, Pressable, ActivityIndicator, TextInput } from "react-native";
// import { customStyles } from "../../theme/styles"
// import SearchIcon from "../../assets/search.svg";
// import { useApiKeyStore } from '../../store/urlApiKeyStore';
// import { initiatePurchase } from "../../constants/constants";
// import ProductListItem from "./ProductListItem";

// interface ProductListProps {
//     navigation: any; // Adjust the type according to your navigation prop type
// }

// declare global {
//     namespace NodeJS {
//         interface Global {
//             instanceId: string; // Adjust the type according to your data
//         }
//     }
// }
// // Assign the type to global
// // declare const global: CustomGlobal;

// export default function ProductList({ navigation }: ProductListProps) {
//     let {setApiKey, setBaseUrl} = useApiKeyStore();
//     useEffect(() => {
//         //setApiKey(props.apiKey);
//         setApiKey("MCAPUBK_TEST|1acf339a-d36f-47e7-8e1b-fd0b76b61b0c");
//         setBaseUrl();
//       },[])

//     const [loading, setLoading] = useState(true);
//     const [products, setProducts] = useState<any[]>([]);
//     const [filters, setFilters] = useState<string[]>([]);
//     const [filterOption, setFilterOption] = useState<string>("All");

//     const url = 'https://staging.api.mycover.ai' + initiatePurchase;


    

//     // const headers = { "Authorization": "Bearer " + apiKey, "Content-Type": "application/json" };
//     const headers = { "Authorization": "Bearer " + "MCAPUBK_TEST|1acf339a-d36f-47e7-8e1b-fd0b76b61b0c", "Content-Type": "application/json" };
//     const jsonBody = JSON.stringify({
//         action: "purchase",
//         payment_option: "gateway"
//     });

//     useEffect(() => {
//         console.log(url);
//         fetch(url, { method: "POST", headers: headers, body: jsonBody })
//             .then((response) => response.json())
//             .then((json) => {
//                 console.log(1);
//                 console.log(1);
//                 console.log(1);
//                 console.log(1); 
//                 console.log(1);
//                 console.log(json);
//                 // console.log(apiKey);
//                 // global.instanceId = json["data"]["businessDetails"]["instance_id"];
//                 setProducts(json["data"]["productDetails"]);
//                 updateFilters(json["data"]["productDetails"]);
//             })
//             .catch((error) => console.log(error))
//             .finally(() => setLoading(false));
//     }, []);

//     function getProductList() {
//         let p = products;

//         if (filterOption.toLowerCase() !== "all") {
//             p = products.filter((item) => item["prefix"] === filterOption);
//         }
//         return p.sort((a, b) => a.name.localeCompare(b.name));
//     }

//     function updateFilters(p: any[]) {
//         const x = new Set<string>().add("All");
//         p.forEach((item) => {
//             x.add(item["prefix"]);
//         });

//         setFilters([...Array.from(x)]);
//     }

//     return (
//         <View style={customStyles.appContainer}>
//             <View style={customStyles.spacerHorizontal}></View>
//             {loading ? (
//                 <View style={{ flex: 1, justifyContent: "center", alignItems: "center", width: "100%" }}>
//                     <ActivityIndicator style={{ margin: 12, borderColor: "#3BAA90" }} animating={loading} />
//                     <Text style={{ fontFamily: "Raleway_500Medium" }}>Fetching Products...</Text>
//                 </View>
//             ) : (
//                 <View style={{ flex: 1, justifyContent: "flex-start" }}>
//                     <Text style={customStyles.titleText}>Product Page</Text>

//                     <View style={{ flexDirection: "row", marginVertical: 4, borderWidth: 0.5, borderRadius: 25, borderColor: "#D0D5DD", alignItems: "center", paddingVertical: 6, paddingHorizontal: 12 }}>
//                         <SearchIcon />
//                         <TextInput style={{ marginLeft: 8, fontFamily: "Raleway_400Regular", flex: 1 }} placeholderTextColor={"#98A2B3"} placeholder="Search Products" />
//                     </View>

//                     {ProductFilterOptions(filters, filterOption, (option) => {
//                         setFilterOption(option);
//                     })}
//                     <FlatList showsVerticalScrollIndicator={false} style={{ paddingBottom: 10 }} contentContainerStyle={{ justifyContent: "flex-start" }} data={getProductList()} renderItem={(itemData) => {
//                         return <ProductListItem navigator={navigation} data={itemData.item} />;
//                     }} keyExtractor={(item, index) => item.id} alwaysBounceVertical={false} />
//                 </View>
//             )}
//         </View>
//     );
// }

// interface ProductFilterOptionsProps {
//     options: string[];
//     filterOption: string;
//     onItemPressed: (option: string) => void;
// }

// function ProductFilterOptions({ options, filterOption, onItemPressed }: ProductFilterOptionsProps) {
//     const style = StyleSheet.create({
//         inactiveContainer: {
//             backgroundColor: 'white',
//             marginHorizontal: 5,
//             paddingVertical: 5,
//             paddingHorizontal: 7,
//             borderRadius: 30,
//             borderWidth: 0.8,
//             borderColor: "#3BAA90",
//             justifyContent: "center"
//         },
//         activeContainer: {
//             backgroundColor: '#3BAA90',
//             marginHorizontal: 5,
//             paddingVertical: 5,
//             paddingHorizontal: 7,
//             borderRadius: 30,
//             borderWidth: 1,
//             borderColor: "#3BAA90",
//             justifyContent: "center"
//         },
//         inactiveText: {
//             textAlign: "center",
//             color: "#3BAA90",
//             fontFamily: "Raleway_400Regular",
//             fontSize: 14,
//             fontWeight: "400"
//         },
//         activeText: {
//             textAlign: "center",
//             color: "white",
//             fontFamily: "Raleway_400Regular",
//             fontSize: 14,
//             fontWeight: "400"
//         }
//     });

//     return (
//         <FlatList showsHorizontalScrollIndicator={false} horizontal={true} style={{ maxHeight: 40, marginVertical: 8 }} data={options} renderItem={(itemData) => {
//             let option = itemData.item;

//             function handleItemPressed() {
//                 onItemPressed(option);
//             }

//             return (
//                 <Pressable onPress={handleItemPressed}>
//                     <View style={option === filterOption ? style.activeContainer : style.inactiveContainer}>
//                         <Text style={option === filterOption ? style.activeText : style.inactiveText}>{option}</Text>
//                     </View>
//                 </Pressable>
//             );
//         }} />
//     );
// }
